// extracted by mini-css-extract-plugin
module.exports = {"container":"_1XREVUiHF6N0xjGOX7cEOs"};